export const TOP_WINDOW = '_top';
export const BLANK_WINDOW = '_blank';
export const SELF_WINDOW = '_self';
export const PARENT_WINDOW = '_parent';
export function openPage(url, windowName) {
  window.open(url, windowName);
}
export const redirectTo = url => {
  window.location.href = url;
};
export const randomUUID = () => window.crypto.randomUUID();